<div class="main-content">
  <div class="main-container">
    <ov-suite-hierarchy-table [title]="'User'" [formClass]="formClass"> </ov-suite-hierarchy-table>
  </div>
</div>
